import React, { useState } from 'react';
import axios from 'axios';
import AxiosClient from '../assets/AxiosClient';
import QR_Defult from "../QrDefult.png"; 
import { useStateContext } from '../Contexts/ContextProvider';

const QrGenrator = () => {
  const [inputValue, setInputValue] = useState('');
  const [qrImageUrl, setQrImageUrl] = useState(QR_Defult);
  const { API } = useStateContext();

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const generateQRCode = async (e) => {
    e.preventDefault();
    try {
      setQrImageUrl(`${API}/GenerateQr/${inputValue}`);
    } catch (error) {
      console.error('Error generating QR code:', error);
    }
  };

  const handleDownloadClick = async () => {
    try {
      const response = await axios.get(qrImageUrl, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'qr-code.png');
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error('Error downloading image:', error);
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="card my-4 m-2 p-3">
            <div className="card-body px-0 m-2 text-dark">
              <h1 className="h4">Generate QR Code</h1>
              <form className="form-group" onSubmit={generateQRCode}>
                <div className="input-group input-group-outline mb-3">
                  <label className="form-label"></label>
                  <textarea type="textarea" className="form-control h6" value={inputValue} onChange={handleInputChange} />
                </div>
                <button type="submit" className="btn btn-dark h5">Generate</button>
              </form>

              <div className=''>
                <img src={qrImageUrl} alt="QR Code" />
                <br/>
                <div className='ml-10'>
                  { qrImageUrl !== QR_Defult && <button className="btn btn-primary" onClick={handleDownloadClick}>Download Image</button> }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </>
  );
};

export default QrGenrator;
